var angular = require("angular");
var amt_admin = require("amt_admin").default;
var app = angular.module("ww2_analytics.dashboard", [amt_admin]);

var main_tpl = require("./main.html");

app.service("dashboard_api", [
  "jsonrpc",
  function(jsonrpc) {
    var service = jsonrpc.newService("dashboard");
    this.total_installs = service.createMethod("total_installs");
    this.total_purchases = service.createMethod("total_purchases");
    this.total_purchases_sum = service.createMethod("total_purchases_sum");
    this.total_purchases_all = service.createMethod("total_purchases_all");
  }
]);

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider.state("amt.ww2.main", {
      url: "/",
      template: main_tpl,
      reloadOnSearch: false,
      data: {
        priority: 1000,
        title: "Dashboard",
        role: "dashboard"
      },
      menu: {
        glyphicon: "home"
      },
      controller: [
        "$scope",
        "$location",
        "dashboard_api",
        "chartFilters",
        "currentUser",
        function(
          $scope,
          $location,
          dashboard_api,
          chartFilters,
          currentUser
        ) {
          $scope.total_installs = { total: 0 };
          $scope.total_purchases = { total: 0 };
          $scope.total_purchases_sum = { total: 0 };

          $scope.update_totals = function(model) {
            if (currentUser.can("dashboard.can_see_total_installs")) {
              dashboard_api.total_installs(model).then(function(resp) {
                $scope.total_installs = resp;
              });
            }
            if (currentUser.can("dashboard.can_see_total_purchases")) {
              dashboard_api.total_purchases(model).then(function(resp) {
                $scope.total_purchases = resp;
              });
            }
            if (currentUser.can("dashboard.can_see_total_purchases_sum")) {
              dashboard_api.total_purchases_sum(model).then(function(resp) {
                $scope.total_purchases_sum = resp;
              });
            }
          };
          chartFilters.onChangeChartParams(
            "update_totals",
            $scope.update_totals
          );
          $scope.update_totals(chartFilters.get_chart_filters());
        }
      ]
    });
  }
]);

export default app.name;
